import React, { useState } from 'react';
import { Button } from 'antd';
import DeleteAttachBtn from '../DeleteAttachBtn/DeleteAttachBtn';
import { getInfoAttachData } from '../../../../requests/getInfoAttachData';
import generateUrlFromBlob from '../../../../../../helpers/generateUrlFromBlob';
import styles from './Files.module.scss';

const Files = ({ files, infoId, onDelete }) => {
  const [downloadedFileId, setDownloadedFileId] = useState(null);
  const handleDeleteAttachBntClick = (e, file) => {
    e.stopPropagation();
    onDelete(file);
  };

  const handleDownload = async (file) => {
    setDownloadedFileId(file.id);
    const attach = await getInfoAttachData(infoId, file.fileName, 'attachment');
    setDownloadedFileId(null);

    const url = generateUrlFromBlob(attach);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.name);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div>
      {files.map((file) => (
        <div className="block-with-delete-button" key={file.id}>
          <Button
            type="dashed"
            icon={downloadedFileId === file.id ? 'loading' : 'paper-clip'}
            className="dspx-button-attach-file"
            onClick={() => handleDownload(file)}
          >
            <span className={styles.name}>{file.name}</span>
            <DeleteAttachBtn
              onClick={(e) => handleDeleteAttachBntClick(e, file)}
              className={styles.deleteBtn}
            />
          </Button>
          <style>{`.dspx-button-attach-file:hover
             .delete-button {display: unset !important;} 
             .delete-button {display: none !important;} `}</style>
        </div>
      ))}
    </div>
  );
};

export default Files;
